// Module
var code = "<correct-place-form model=\"item\" on-close=\"$close(model)\">\n</correct-place-form>";
// Exports
module.exports = code;